module.exports = __webpack_public_path__ + "img/ico_badge06.8d518ef9.svg";